export const GalleryImageCard = ({ photo, delay = 0, onClick }) => (
  <div
    className="fade-in hover-lift cursor-pointer"
    style={{ animationDelay: `${delay}s` }}
    onClick={() => onClick(photo)}
    data-testid={`gallery-image-${photo.id}`}
  >
    <div className="relative rounded-2xl overflow-hidden shadow-xl border-2 border-primary group">
      <img
        src={photo.url}
        alt={photo.caption}
        className="w-full h-80 object-cover transition-transform duration-300 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 via-blue-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <p className="font-sans text-white text-lg font-medium">{photo.caption}</p>
        </div>
      </div>
    </div>
  </div>
);
